const JOURNEY_STORAGE_KEY = 'sb_analytics_journey_v1'
const SESSION_STORAGE_KEY = 'sb_analytics_session_v1'
const JOURNEY_TTL_MS = 90 * 24 * 60 * 60 * 1000
const SESSION_TIMEOUT_MS = 30 * 60 * 1000

const readState = (storage, key) => {
  try {
    const value = storage?.getItem(key)
    return value ? JSON.parse(value) : null
  } catch {
    return null
  }
}
const writeState = (storage, key, value) => {
  try {
    storage?.setItem(key, JSON.stringify(value))
  } catch {
    // Storage can be blocked; analytics must fail open without identity.
  }
}

export function resolveAnalyticsIdentity({
  storage,
  now = Date.now(),
  idFactory = () => globalThis.crypto?.randomUUID?.() || `${now}-${Math.random()}`,
} = {}) {
  let journey = readState(storage, JOURNEY_STORAGE_KEY)
  const journeyExpired = !journey?.id || !journey?.expiresAt || journey.expiresAt <= now

  if (journeyExpired) {
    journey = { id: idFactory(), expiresAt: now + JOURNEY_TTL_MS }
    writeState(storage, JOURNEY_STORAGE_KEY, journey)
  }

  let session = readState(storage, SESSION_STORAGE_KEY)
  const sessionExpired =
    journeyExpired ||
    !session?.id ||
    session.journeyId !== journey.id ||
    typeof session.lastActivity !== 'number' ||
    now - session.lastActivity > SESSION_TIMEOUT_MS

  if (sessionExpired) {
    session = { id: idFactory(), journeyId: journey.id, lastActivity: now }
  } else {
    session.lastActivity = now
  }
  writeState(storage, SESSION_STORAGE_KEY, session)

  return { journey_id: journey.id, session_id: session.id }
}

export function clearAnalyticsIdentity(storage) {
  try {
    storage?.removeItem(JOURNEY_STORAGE_KEY)
    storage?.removeItem(SESSION_STORAGE_KEY)
  } catch {
    // Storage can be unavailable; there is nothing else to clear here.
  }
}

export const analyticsIdentityConstants = {
  JOURNEY_STORAGE_KEY,
  SESSION_STORAGE_KEY,
  JOURNEY_TTL_MS,
  SESSION_TIMEOUT_MS,
}
